import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'FinalizedCombiBoolean' })
export class FinalizedCombiBoolean implements PipeTransform {
    transform(value: boolean): string {
        return value == true ? 'Yes' : 'No'
    }; 
}